var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.object.amount)+" "+_vm._s(_vm.object.currency)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }